module.exports = "https://web-assets.ifttt.com/packs/media/home/home_header_services-8519854d.png";